import type { HttpClient } from "./http-common"
import type { TDescription } from "@/models/common.model"
import { tryCatch } from "@/lib/try-catch"
import { OrganisationMapper } from "@/mappers/organisation.mapper"
import ApiServiceFactory from "./api-service-factory"

type OrganisationResponse = {
  code: string
  description: TDescription
  order: number
}

export class OrganisationService {
  private httpClient: HttpClient

  constructor(httpClient: HttpClient) {
    this.httpClient = httpClient
  }

  async getAllOrganisations() {
    const response = await tryCatch(
      this.httpClient.get<OrganisationResponse[]>("organisations"),
    )

    if (response.error) {
      return response
    }

    return {
      ...response,
      data: OrganisationMapper.toDto(response.data),
    }
  }
}

export const organisationService = ApiServiceFactory.createService(
  OrganisationService,
  "",
)
